import {
  Component,
  DestroyRef,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ElementRef,
  AfterViewInit,
  OnInit,
  OnChanges,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FormEditor } from '../../../../shared/utils/form-editor';
import { ChainsService } from '../../../../admin/chains/services/chains.service';
import { SearchSelectOption } from 'app/core-lib/inputs/search-select-input/search-select-input.component';
import { Chain } from '../../../model/hotel_dto.model';

@Component({
    selector: 'mh-customer-hotel-chain-form',
    templateUrl: './hotel-chain-form.component.html',
    providers: [FormEditor],
    standalone: false
})
export class CustomerHotelChainFormComponent implements OnInit, OnChanges, AfterViewInit {

  hotel_chain_property = ['chain', 'internal_code', 'internal_name', 'brand', 'region']

  listChains: any;

  chainOptions: SearchSelectOption[] = [];
  chainSearchLoading = false;
  private readonly destroyRef = inject(DestroyRef);

  chainToOption = (chain: Chain | null): SearchSelectOption | null =>
    chain?.id ? { value: chain.id, label: chain.name } : null;

  optionToChain = (option: SearchSelectOption | null): Chain =>
    option ? ({ id: Number(option.value), name: option.label } as Chain) : new Chain();

  @Input()
  parentForm: FormGroup;

  @Input()
  hotelBase;

  @Input()
  hotelDto;

  @Input()
  listOptions = {};

  @Input()
  canEdit = false;

  @Output()
  isReady: EventEmitter<string> = new EventEmitter();

  @Output()
  waiting: EventEmitter<boolean> = new EventEmitter();

  // mh-core-lib-button renderiza un <button> sin type, que dentro del <form> del hotel
  // haría submit al clickear. Se parchea a type="button" en cuanto aparecen.
  @ViewChildren('chainActionButton', { read: ElementRef })
  chainActionButtonRefs: QueryList<ElementRef<HTMLElement>>;


  constructor(
    private router: Router,
    private chainsService: ChainsService) {
  }

  ngOnInit() {
    this.isReady.emit("chain");
  }

  ngAfterViewInit() {
    this.patchButtonTypes();
    this.chainActionButtonRefs.changes
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.patchButtonTypes());
  }

  private patchButtonTypes() {
    this.chainActionButtonRefs?.forEach(ref => {
      const button = ref?.nativeElement?.querySelector('button');
      if (button) button.type = 'button';
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hotelDto !== undefined) this.setForChain();
  }

  setForChain() {
    const chainControl = this.chain_property?.get('chain');
    const currentChain = chainControl?.value;
    if (!currentChain?.id || currentChain.name) return;

    this.chainsService
      .searchChains(undefined, currentChain.id)
      .pipe(
        catchError(() => of(null)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((res) => {
        const row = res?.data?.info?.[0];
        if (row) chainControl.patchValue({ id: row.chain_id, name: row.chain_name }, { emitEvent: false });
      });
  }

  goToChainsManager() {
    this.router.navigate(['/admin/chains']);
  }

  goToCreateChain() {
    this.router.navigate(['/admin/chains'], { queryParams: { create: 'chain' } });
  }

  get chain_property() { return this.parentForm.get('chain_property'); }

  onChainCatalogLoadRequested() {
    this.chainSearchLoading = true;
    this.chainsService
      .getChainNames()
      .pipe(
        catchError(() => of(null)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((res) => {
        this.chainSearchLoading = false;
        this.chainOptions = (res ?? []).map((chain) => ({ value: chain.id, label: chain.name }));
      });
  }
}
